export default __webpack_public_path__ + "static/media/imgPlaceholder.6a3a2116.png";